import {Component, Input, Output, EventEmitter, OnChanges, ChangeDetectionStrategy} from '@angular/core';
import {CartItem} from './cart-item';
import {ProjectService} from '../../services/project.service';
import {CartService} from '../../services/cart.service';
import {Size} from '../../models/size';
import {BreakpointObserver} from "@angular/cdk/layout";
import {PartDisplayService} from "../../services/part-display.service";

@Component({
    selector: 'mbnm-cart-item',
    templateUrl: './cart-item.component.html',
    styleUrls: ['./cart-item.component.scss'],
    host: {
        '[class.updating]': 'cartItem.updating',
        '[class.readonly]': 'readonly',
        '[class.deleted]': 'deleted'
    },
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class CartItemComponent implements OnChanges {

  @Input()
  cartItem: CartItem;

  @Input()
  readonly: boolean;

  @Input()
  deleted: boolean;

  @Input()
  enableReBuy = false;

  @Input()
  hideDivider = false;

  @Output()
  itemRemoved: EventEmitter<CartItem> = new EventEmitter<CartItem>();

  @Output()
  qtyUpdate: EventEmitter<any> = new EventEmitter();

  @Output()
  reBuyRequested: EventEmitter<any> = new EventEmitter();

  qty: number;

  qtyUpdateTimeout;

  constructor(private projectService: ProjectService, private cartService: CartService, public media: BreakpointObserver, private partDisplay: PartDisplayService) { }

  ngOnChanges() {
    this.setHeading();
    this.cartService.setCartItemExtras(this.cartItem);
    this.qty = this.cartItem.qty;
  }

  public removeItem($event): void {
    $event.currentTarget.blur();
    this.cartItem.updating = true;
    this.itemRemoved.emit(this.cartItem);
  }

  public updateQty(): void {
    clearTimeout(this.qtyUpdateTimeout);
    if (!isNaN(this.qty) && this.qty !== null) {
      this.qtyUpdateTimeout = setTimeout(() => {
        this.cartItem.updating = true;
        this.qtyUpdate.emit({ id: this.cartItem.id, qty: this.qty });
      }, 500);
    }
  }

  private setHeading(): void {
    if (this.cartItem) {
      const item = this.cartItem;
      if (item.title) {
        item.heading = item.title;
      } else if (item.primaryProduct === 'MAT' && item.topMat) {
        item.heading = item.topMat.categoryName;
      } else if (item.primaryProduct === 'MIRROR' && this.partDisplay.description(item.mirror)) {
        item.heading = this.partDisplay.description(item.mirror);
      } else if ((item.primaryProduct === 'FRAME' || item.primaryProduct === 'MFRAME') && this.partDisplay.longDescription(item.moulding)) {
        item.heading = this.partDisplay.description(item.moulding) + ' Frame';
      } else if (item.primaryProduct === 'BACKINGBOARD' && this.partDisplay.description(item.backingBoard)) {
        item.heading = this.partDisplay.description(item.backingBoard);
      } else if (item.primaryProduct === 'GLAZING' && this.partDisplay.description(item.glazing)) {
        item.heading = this.partDisplay.description(item.glazing);
      } else if (item.primaryProduct === 'SHOWBAG') {
        item.heading = 'Show Bags';
      } else if (item.primaryProduct === 'SHOW-KIT') {
        item.heading = this.getSampleProductDesc(item) + ' Show Kit';
      } else if (item.primaryProduct === 'VALUE-PACK') {
        item.heading = this.getSampleProductDesc(item) + ' Value Pack';
      } else if (item.primaryProduct === 'SAMPLE') {
        if (item.samples && item.samples.length > 0) {
          item.heading = 'Product Samples';
        } else {
          item.heading = this.getSampleProductDesc(item) + ' Sample';
        }
      } else if (item.description) {
        item.heading = item.description;
      }
    }
  }

  private getSampleProductDesc(item: CartItem): string {
    let desc = '';
    if (item.topMat) {
      desc = item.topMat.categoryName;
    } else if (item.mirror) {
      desc = this.partDisplay.description(item.mirror);
    } else if (item.moulding) {
      desc = this.partDisplay.description(item.moulding);
    } else if (item.backingBoard) {
      desc = this.partDisplay.description(item.backingBoard);
    } else if (item.glazing) {
      desc = this.partDisplay.description(item.glazing);
    } else if (item.bag) {
      desc = 'Show Bags';
    }
    return desc;
  }

  requestReBuy($event) {
    $event.currentTarget.blur();
    this.reBuyRequested.emit({
      item: this.cartItem
    });
  }
}
